import React from 'react';
import { OPERATIONAL_STATUS } from '@/constants/operationalTruth';

const STATUS_STYLES = {
  [OPERATIONAL_STATUS.REAL]: {
    bg: 'bg-emerald-500/10',
    border: 'border-emerald-500/25',
    text: 'text-emerald-400',
    dot: 'bg-emerald-400',
    label: 'REAL'
  },
  [OPERATIONAL_STATUS.DEMO]: {
    bg: 'bg-amber-500/10',
    border: 'border-amber-500/25',
    text: 'text-amber-400',
    dot: 'bg-amber-400',
    label: 'DEMO'
  },
  [OPERATIONAL_STATUS.STATIC]: {
    bg: 'bg-slate-800/80',
    border: 'border-slate-700/50',
    text: 'text-slate-400',
    dot: 'bg-slate-500',
    label: 'STATIC'
  },
  [OPERATIONAL_STATUS.INCOMPLETE]: {
    bg: 'bg-rose-500/10',
    border: 'border-rose-500/25',
    text: 'text-rose-400',
    dot: 'bg-rose-400',
    label: 'INCOMPLETE'
  },
  [OPERATIONAL_STATUS.PLANNED]: {
    bg: 'bg-purple-500/10',
    border: 'border-purple-500/25',
    text: 'text-purple-400',
    dot: 'bg-purple-400',
    label: 'PLANNED'
  }
};

const OperationalStatusBadge = ({
  status = OPERATIONAL_STATUS.STATIC,
  label,
  size = 'md',
  className = ''
}) => {
  const current = STATUS_STYLES[status] || STATUS_STYLES[OPERATIONAL_STATUS.STATIC];
  const displayLabel = label || current.label;

  const sizeClasses = size === 'sm'
    ? 'px-1.5 py-0.5 text-[9px] gap-1'
    : 'px-2 py-0.5 text-[10px] gap-1.5';

  return (
    <span
      data-testid={`operational-status-badge-${status.toLowerCase()}`}
      className={`inline-flex items-center font-sans font-medium border rounded-full select-none ${current.bg} ${current.border} ${current.text} ${sizeClasses} ${className}`}
      title={`Operational Status: ${status}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${current.dot}`} />
      <span>{displayLabel}</span>
    </span>
  );
};

export default OperationalStatusBadge;
